import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ChevronRightIcon } from 'lucide-react';
import { AtnaAssistant } from '../components/collectes/AtnaAssistant';
import { AddressCard } from '../components/collectes/AddressCard';
import { CollectionCalendar } from '../components/collectes/CollectionCalendar';
import { DayDetails } from '../components/collectes/DayDetails';
export function CalendrierCollectes() {
  const [month, setMonth] = useState(new Date(2026, 7, 1));
  const [selected, setSelected] = useState(new Date(2026, 7, 27));
  const handleSelect = (date: Date) => {
    setSelected(date);
    if (date.getMonth() !== month.getMonth()) setMonth(new Date(date.getFullYear(), date.getMonth(), 1));
  };
  return <main className="bg-white" data-id="element-2813" data-mp="29ws9u8ycqs5u">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2814" data-mp="akpjqfv82zj7">
        <nav aria-label="Fil d’Ariane" className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500" data-id="element-2815" data-mp="amsknuxwyd2p">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2816" data-mp="35253d6z9iqpc">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2817" data-mp="30b6lw42jfmki" />
          <Link to="/mes-collectes" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2818" data-mp="2vcbsy9auwhmo">
            Mes collectes
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2819" data-mp="2rbs03hxbg06c" />
          <span aria-current="page" data-id="element-2820" data-mp="3o0r9j09mz804">Calendrier</span>
        </nav>

        <header className="mt-4 flex flex-wrap items-end justify-between gap-4" data-id="element-2821" data-mp="3nywu21h4w83f">
          <div data-id="element-2822" data-mp="3j2g02qn96zif">
            <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2823" data-mp="3iztnudpf3vtv">Mes collectes</h1>
            <p className="mt-2 text-[17px] text-slate-600" data-id="element-2824" data-mp="3a18bj0ajhd1j">Calendrier personnalisé pour votre adresse</p>
          </div>
        </header>

        <div className="mt-8" data-id="element-2825" data-mp="23lfpu0ellrcl">
          <AtnaAssistant data-id="element-2826" data-mp="23mh3mcn00ry0" />
        </div>

        <div className="mt-6" data-id="element-2827" data-mp="1ymckeeuphj43">
          <AddressCard data-id="element-2828" data-mp="1yl1gmf19gbcz" />
        </div>

        <Link to="/mes-collectes" className="mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-ville-deep underline underline-offset-4 transition-colors duration-150 ease-ville hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2829" data-mp="1yo5vq7g9krif">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-2830" data-mp="1v45c77zog6jn" />
          Retour à Mes collectes
        </Link>

        <div className="mt-6 grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,420px)] lg:gap-10" data-id="element-2831" data-mp="1hd0iemizq8h8">
          <CollectionCalendar month={month} selected={selected} onMonthChange={setMonth} onSelect={handleSelect} data-id="element-2832" data-mp="1m37aiwcpob48" />
          <DayDetails date={selected} data-id="element-2833" data-mp="17fcfh9b8dunz" />
        </div>
      </div>
    </main>;
}